import type { ReactNode } from 'react';
import { GLASS_SURFACE } from '../CategoryPill';

export interface StatusBadgeProps {
  label: string;
  icon?: ReactNode;
  className?: string;
}

/**
 * Glass-pill status overlay used on hero surfaces (e.g. "Restoring",
 * "Sold out"). Sized to content — the caller positions it.
 */
export function StatusBadge({ label, icon, className = '' }: StatusBadgeProps) {
  return (
    <div
      role="status"
      className={
        GLASS_SURFACE +
        ' inline-flex items-center gap-2 rounded-full ' +
        'px-4 py-2 text-white type-body-semi ' +
        className
      }
    >
      {icon && (
        <span aria-hidden className="flex size-6 items-center justify-center">
          {icon}
        </span>
      )}
      <span>{label}</span>
    </div>
  );
}

